module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAKCAYAAADRuIyZAAAAAXNSR0IArs4c6QAAAKhJREFUOE/N1LEKQiEUxvHvaENDQb1b8xGhxqDGnqCxoLELcp17t4IaGlKjRUy8TUI6/+H8hnMkNPKoEQcixBgzFkKciGgBYASgc87ttNbPErZ2HyHW2gOATTo0hNAppVYlSO0+hdwBTDLITSk1H4BU7VPIFcAsG/pg5ukApGofIX3fn4lomQ09MvO2BKndfy2rlHIP4IN5hRAu3vv1r2Wt2bd3vv/+T94jnJALKSbVAgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img46.png
// module id = 2xTG
// module chunks = 1